import React from "react";
import {
  Heading,
  Card,
  Link,
  theme,
  MarketingIcon
} from "@icg360/design-system";
import { styled } from "styled-components";

import type { MarketingIconNames } from "@icg360/design-system";

const StyledLink = styled(Link)`
  text-decoration: none;
  color: ${theme.colors.text.default};

  :hover,
  .text-text-interactive:hover {
    color: ${theme.colors.text.default};
  }
`;

const StyledLinkCard = styled(Card)`
  position: relative;
  display: flex;
`;

const StyledHeading = styled(Heading)`
  margin: 0 0 5px;
  font-size: 14px;
`;

const StyledIconContainer = styled.div`
  color: ${theme.colors.fill.quiet};

  svg {
    position: absolute;
    left: 22px;
    top: calc(50% - 18px);
    width: 36px;
    height: 36px;
  }

  &:hover {
    svg {
      path {
        color: ${theme.colors.fill.quiet};
      }
    }
  }
`;

const StyledCardContent = styled.div`
  padding: ${theme.spacing.lg} ${theme.spacing.xl} ${theme.spacing.md} 80px;
  min-height: ${theme.spacing["5xl"]};
`;

interface LoginItemProps {
  title: string;
  message: string;
  url: string;
  target: string;
  iconName: string;
}

export const LoginItem = ({
  title,
  message,
  url,
  target,
  iconName
}: LoginItemProps) => {
  return (
    <StyledLink href={url} target={target}>
      <StyledLinkCard>
        <StyledIconContainer>
          <MarketingIcon name={iconName as MarketingIconNames} size="lg" />
        </StyledIconContainer>
        <StyledCardContent>
          <StyledHeading tag="h4" size="sm">
            {title}
          </StyledHeading>
          <p>{message}</p>
        </StyledCardContent>
      </StyledLinkCard>
    </StyledLink>
  );
};
